import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'CHANNEL',
  entryPoint: '/channels',
  collectionName: 'channels',
  querySearchListing: [
    ['name', 'type', 'protocol', 'enabled', 'settings'],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Channel created',
  successMessageUpdate: 'Channel updated',
  successMessageDelete: 'Channel deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/triggers.js